import Wait from './Wait';

const clearMessageTimeoutInSeconds = 0.25;

const readAlert = async (message: string): Promise<void> => {
   try {
      const ariaLiveStatusElement = document.getElementById('aria-live-status');
      ariaLiveStatusElement.innerText = message;
      await Wait.seconds(clearMessageTimeoutInSeconds);
      ariaLiveStatusElement.innerText = '';
   } catch (e) {
      console.info(e);
   }
};

export default {
   readAlert
};